import {
	// PAGES Tags
	tagByID,
	tagCreate,
	tagDestroy,
	tagUpdate,
	tagsList,
} from '@/services/pageTags.service'

export default {
	namespaced: true,
	state: {
		// PAGE TAGS
		tagsList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		tag: {},
		// STATUS TAGS
		tagsStatus: 'pending',
		tagsSaveStatus: 'init',
		tagsDeleteStatus: 'init',
	},
	getters: {
		// PAGE TAGS
		getTagsList(state) {
			return state.tagsList
		},
		getTag(state) {
			return state.tag
		},
		// PAGE TAGS
		getTagsDeleteStatus(state) {
			return state.tagsDeleteStatus
		},
		getTagsSaveStatus(state) {
			return state.tagsSaveStatus
		},
		getTagsStatus(state) {
			return state.tagsStatus
		},
	},
	mutations: {
		// PAGE TAGS
		TAGS_LIST(state, value) {
			state.tagsList = value
		},
		SET_TAG(state, value) {
			state.tag = value
		},
		// STATUS PAGE TAGS
		TAGS_STATUS(state, value) {
			state.tagsStatus = value
		},
		TAG_SAVE_STATUS(state, value) {
			state.tagsSaveStatus = value
		},
		TAG_DELETE_STATUS(state, value) {
			state.tagsDeleteStatus = value
		},
	},
	actions: {
		// Page Tags
		async fetchTagList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('TAGS_STATUS', 'pending')
			commit('TAGS_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await tagsList(params)
				commit('TAGS_STATUS', 'init')
				commit('TAGS_LIST', data)
				return data
			} catch (error) {
				commit('TAGS_STATUS', 'init')
				throw error
			}
		},
		async fetchTagByID({ commit }, params) {
			commit('TAGS_STATUS', 'pending')
			try {
				const { data } = await tagByID(params)
				commit('TAGS_STATUS', 'init')
				commit('SET_TAG', data.data)
				return data
			} catch (error) {
				commit('TAGS_STATUS', 'init')

				return error
			}
		},
		async saveNewTag({ commit }, params) {
			commit('TAG_SAVE_STATUS', 'pending')
			try {
				const { data } = await tagCreate(params)
				commit('TAG_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TAG_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateTag({ commit }, params) {
			commit('TAG_SAVE_STATUS', 'pending')
			try {
				const { data } = await tagUpdate(params)
				commit('TAG_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TAG_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteTagByID({ commit }, params) {
			commit('TAG_DELETE_STATUS', 'pending')
			try {
				const { data } = await tagDestroy(params)
				commit('TAG_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TAG_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
